import React, { useRef } from 'react'

import { AgGridColumnProps, AgGridReact } from 'ag-grid-react'
import { useRouter } from 'next/router'

import { AuditCheckStatusRenderer } from './AuditCheckStatusRenderer'
import { getColumnData } from './utils'
import { useGetAuditCheckSummaryQuery } from '@/services/application'

const colDefs: AgGridColumnProps[] = [
  { headerName: 'Field', field: 'field', pinned: true },
  {
    headerName: 'Credit Report',
    field: 'creditReport',
    width: 128,
    cellRenderer: AuditCheckStatusRenderer,
  },
  {
    headerName: 'AVM Report',
    field: 'avmReport',
    width: 128,
    cellRenderer: AuditCheckStatusRenderer,
  },
  {
    headerName: 'Title Report',
    field: 'titleReport',
    width: 128,
    cellRenderer: AuditCheckStatusRenderer,
  },
  {
    headerName: 'Appraisal Report',
    field: 'appraisalReport',
    width: 148,
    cellRenderer: AuditCheckStatusRenderer,
  },
]

export function AuditResults() {
  const gridRef = useRef<AgGridReact>(null)
  const router = useRouter()
  const { id: applicationId } = router.query
  const { data = {} } = useGetAuditCheckSummaryQuery(applicationId, {
    skip: !applicationId,
  })

  // Backend returns an object with keys & empty values if there is no audit check data
  const hasAuditCheckData = Object.values(data).some((item) => Object.values(item).length > 0)

  return (
    <>
      {!hasAuditCheckData && (
        <div className='flex flex-col items-center justify-center h-[200px]'>
          <div className='text-2xl font-semibold text-gray-700'>No Audit Check Data</div>
          <div className='text-sm text-gray-500'>
            There is no audit check data for this application yet.
          </div>
        </div>
      )}
      {hasAuditCheckData && (
        <>
          <div className='ag-theme-alpine h-[400px] w-full'>
            <AgGridReact
              columnDefs={colDefs}
              ref={gridRef}
              rowData={getColumnData(data)}
            />
          </div>
        </>
      )}
    </>
  )
}
